import { getClientAltText, getClientCode } from '../../selectors/client';

import DefaultLogo from '../../assets/kaboodle-logo-white.png';
import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import constants from '../../constants';
import { goToRoute } from '../../lib/router';
import styles from './HeaderLogo.styles';
import { withStyles } from '@kaboodle-solutions/design-system';

const HeaderLogo = ({
  goTo,
  url,
  code,
  useDefaultLogo,
  altText,
  classes,
  light,
}) => {
  if (!code) {
    return null;
  }

  let imageUrl = '';

  if (useDefaultLogo && code === 'KB') {
    imageUrl = DefaultLogo;
  } else if (light && code !== 'SB') {
    imageUrl = `https://dye1vg6h1p5m0.cloudfront.net/${code}/cav2/header-logo-light.png`;
  } else {
    imageUrl = `https://dye1vg6h1p5m0.cloudfront.net/${code}/cav2/header-logo.png`;
  }

  const images = (
    <img
      className={classes.logo}
      src={imageUrl}
      alt={altText}
      data-test="header-logo"
    />
  );

  if (!url) {
    return <>{images}</>;
  }

  const handleClick = event => {
    event.preventDefault();
    goTo(constants.BOOKINGS_URL);
  };

  return (
    <a
      data-test="header-logo-link"
      href={url}
      onClick={handleClick}
      rel="noopener noreferrer"
      className="header-logo-link">
      {images}
    </a>
  );
};

HeaderLogo.propTypes = {
  altText: PropTypes.string,
  classes: PropTypes.object,
  code: PropTypes.string,
  goTo: PropTypes.func.isRequired,
  light: PropTypes.bool,
  url: PropTypes.string,
  useDefaultLogo: PropTypes.bool,
};

HeaderLogo.defaultProps = {
  altText: '',
  classes: {},
  code: '',
  light: false,
  url: '',
  useDefaultLogo: false,
};

const mapStateToProps = state => ({
  altText: getClientAltText(state),
  code: getClientCode(state),
  url: '/',
});

const mapDispatchToProps = {
  goTo: goToRoute,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(HeaderLogo);
